import sidewinder from "../components/img/sidewinder-logo.png";
import azbowl from "../components/img/azbowl-logo.png";
import bens from "../components/img/gentle-bens.png";
import trc from "../components/img/trc.png";
import innit from "../components/img/innit.png";
import azmvb from "../components/img/azmvb.png";
import diggin from "../components/img/diggin.png";

export const SponsorList = [
	{
		type: "title",
		name: "Sidewinder Volleyball Academy",
		img: sidewinder,
		url: "http://SidewinderVA.com",
	},
	{
		type: "title",
		name: "The Arizona Bowl",
		img: azbowl,
		url: "http://TheArizonaBowl.com",
	},
	{
		type: "local",
		name: "Arizona Men's Volleyball",
		img: azmvb,
		url: "https://www.uofamensvolleyball.com",
	},
	{
		type: "local",
		name: "Gentle Ben's",
		img: bens,
		url: "https://www.gentlebens.com",
	},
	{
		type: "local",
		name: "Tucson Racquet and Fitness Club",
		img: trc,
		url: "https://tucsonracquetclub.com",
	},
	{
		type: "league",
		name: "Innit (Anza Park)",
		img: innit,
		url: "https://https://www.innitlife.com/volleyball",
	},
	{
		type: "league",
		name: "Diggin'It AZ",
		img: diggin,
		url: "https://www.digginitaz.com",
	},
];
